<template>
  <div>
    <b>{{filter.values.comparison_one.label}}</b> {{filter.values.threshold_one}}
    <template v-if="filter.values.comparison_two && filter.values.threshold_two">
    and <b>{{filter.values.comparison_two.label}}</b> {{filter.values.threshold_two}}
    </template>
    <template v-if="filter.values.timezone">
      <b>in Timezone</b> {{filter.values.timezone}}
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      filter: Object,
      dateType: String
    },
    name: 'dateParamsTemplate',
    data () {
      return {
        labelText: this.dateType + ' date is'
      }
    }
  }
</script>
<style>
</style>
